"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendJobApplicationEmails = void 0;
var main_1 = require("../reducers/slices/main");
var send_generic_email_1 = require("../api/calls/notification/send_generic_email");
var sendJobApplicationEmails = function (_a) {
    var applicant = _a.applicant, employer = _a.employer, jobDetails = _a.jobDetails, dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var applicantName, applicantEmail, employerName, employerEmail, jobTitle, jobId, applicantErrorMessage, res, e_1, employerErrorMessage, res, e_2;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    applicantName = applicant.name, applicantEmail = applicant.email;
                    employerName = employer.name, employerEmail = employer.email;
                    jobTitle = jobDetails.title, jobId = jobDetails.id;
                    if (!applicantEmail) return [3 /*break*/, 4];
                    applicantErrorMessage = ["There was an error sending the confirmation email to your address.", "Be assured that your application was received."];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, send_generic_email_1.send_generic_email)({
                            to: applicantEmail,
                            subject: "Job Application Submission",
                            from: (_b = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _b !== void 0 ? _b : "",
                            template_id: "".concat(process.env.JOB_APPLICATION_APPLICANT_EMAIL_TEMPLATE_ID),
                            data: {
                                full_name: applicantName,
                                job_title: jobTitle,
                                employer_name: employerName,
                                job_id: jobId,
                                job_link: "".concat(window.location.origin, "/#/job/").concat(jobId),
                                support_email: (_c = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _c !== void 0 ? _c : "",
                            },
                        })];
                case 2:
                    res = _e.sent();
                    if (res.error === true) {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Email Notification Failed",
                            messages: applicantErrorMessage,
                        }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _e.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Email Notification Failed",
                        messages: applicantErrorMessage,
                    }));
                    return [3 /*break*/, 4];
                case 4:
                    if (!employerEmail) return [3 /*break*/, 8];
                    employerErrorMessage = ["There was an error sending the confirmation email to the employer.", "Be assured that your application was received."];
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, (0, send_generic_email_1.send_generic_email)({
                            to: employerEmail,
                            subject: "Job Application Submission",
                            from: applicantEmail,
                            template_id: "".concat(process.env.JOB_APPLICATION_EMPLOYER_EMAIL_TEMPLATE_ID),
                            data: {
                                full_name: applicantName,
                                job_title: jobTitle,
                                employer_name: employerName,
                                job_id: jobId,
                                support_email: (_d = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _d !== void 0 ? _d : "",
                                applicant_email: applicantEmail,
                            },
                        })];
                case 6:
                    res = _e.sent();
                    if (res.error === true) {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Email Notification Failed",
                            messages: employerErrorMessage,
                        }));
                    }
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _e.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Email Notification Failed",
                        messages: employerErrorMessage,
                    }));
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
};
exports.sendJobApplicationEmails = sendJobApplicationEmails;
